import {Component, OnInit} from '@angular/core';
import {MatDialog, MatSnackBar} from '@angular/material';

import {FuseTranslationLoaderService} from '../../../core/services/translation-loader.service';
import {ErrorResponse} from '../../../data/model/errorResponse';
import {Module} from '../../../data/model/module';
import {ModuleVisibility} from '../../../data/model/moduleVisibility';
import {ModulesDataManager} from '../../../data/modules.datamanager';
import {OrganisationsDataManager} from '../../../data/organisations.datamanager';
import {ConfirmDialogComponent} from '../dialogs/confirm/confirm.dialog.component';

import {AddModuleDialogComponent} from './add/add.module.dialog.component';
import {AddOrganisationModuleDialogComponent} from './addOrganisation/add.organisation.module.dialog.component';
import {locale as english} from './i18n/en';
import {locale as turkish} from './i18n/tr';
import { EditModuleDialogComponent } from './edit/edit.module.dialog.component';

@Component({
  selector: 'fuse-courses',
  templateUrl: './modules.component.html',
  styleUrls: ['./modules.component.scss']
})
export class FuseModulesComponent implements OnInit {
  rows: Module[];

  constructor(
      private dialog: MatDialog, private snackbar: MatSnackBar,
      private modulesDataManager: ModulesDataManager,
      private organisationsDataManager: OrganisationsDataManager,
      public snackBar: MatSnackBar,
      private translationLoader: FuseTranslationLoaderService) {
    this.translationLoader.loadTranslations(english, turkish);
  }

  ngOnInit() {
    this.modulesDataManager.getAllModules().subscribe(
        (response) => {
          this.rows = response;
        },
        (err) => {
          this.showError(err.json());
          console.log(err);
        });
  }

  editModuleButtonClick(moduleId: string, rowIndex: number){
    const moduleObject = this.rows[rowIndex];

    const dialogRef = this.dialog.open(EditModuleDialogComponent, {
      height: '420px',
      width: '800px',
      data: {
        module: moduleObject
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== null && result !== undefined) {
        if (typeof result === 'string') {
          this.showMessage(result);
          this.ngOnInit();
        } else {
          this.showError(result);
        }
      }
    });
  }

  addModuleButtonClick() {
    const dialogRef = this.dialog.open(
        AddModuleDialogComponent, {height: '480px', width: '600px', data: {}});

    dialogRef.afterClosed().subscribe(result => {
      if (result !== null && result !== undefined) {
        if (typeof result === 'string') {
          this.showMessage(result);
          this.ngOnInit();
        } else {
          this.showError(result);
        }
      }
    });
  }

  manageOrganisation(rowIndex) {
    this.organisationsDataManager.getAllOrganisations().subscribe(
        (response) => {
          const module = this.rows[rowIndex];
          const organisationStrings = response.map(a => a._id);
          const visibilityOrg = module.visibility.map(a => a.organisation);

          organisationStrings.forEach(organisation => {
            let visibilityObject: ModuleVisibility;
            const roleList: string[] = [];

            if (!visibilityOrg.includes(organisation)) {
              let visibility = new ModuleVisibility();
              visibility.organisation = organisation;
              visibility.visible = false;
              visibility.role = 'appuser';
              module.visibility.push(visibility);

              visibility = new ModuleVisibility();
              visibility.organisation = organisation;
              visibility.visible = false;
              visibility.role = 'admin';
              module.visibility.push(visibility);

              visibility = new ModuleVisibility();
              visibility.organisation = organisation;
              visibility.visible = false;
              visibility.role = 'instructor';
              module.visibility.push(visibility);
            } else {
              for (let i = 0; i < 3; i++) {
                const index = visibilityOrg.indexOf(organisation);
                if (index >= 0) {
                  visibilityObject = module.visibility[index];
                  roleList.push(visibilityObject.role);
                  delete visibilityOrg[index];
                }
              }
              if (!roleList.includes('admin')) {
                const visibility = new ModuleVisibility();
                visibility.organisation = organisation;
                visibility.visible = false;
                visibility.role = 'admin';
                module.visibility.push(visibility);
              }
              if (!roleList.includes('appuser')) {
                const visibility = new ModuleVisibility();
                visibility.organisation = organisation;
                visibility.visible = false;
                visibility.role = 'appuser';
                module.visibility.push(visibility);
              }
              if (!roleList.includes('instructor')) {
                const visibility = new ModuleVisibility();
                visibility.organisation = organisation;
                visibility.visible = false;
                visibility.role = 'instructor';
                module.visibility.push(visibility);
              }
            }
          });

          const dialogRef =
              this.dialog.open(AddOrganisationModuleDialogComponent, {
                height: '500px',
                width: '800px',
                data: {'module': module, 'organisations': response}
              });

          dialogRef.afterClosed().subscribe(result => {
            if (result !== null && result !== undefined) {

              this.modulesDataManager.updateModuleVisability(module._id, result)
                  .subscribe(
                      (resp) => {
                        console.log(resp);
                        this.showMessage('Organisations successfuly updated');
                      },
                      (err) => {
                        this.showError(err.json());
                      });
            }
          });
        },
        (err) => {
          this.showError(err.json());
          console.log(err);
        });
  }

  removeModule(moduleId) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      height: '170px',
      width: '300px',
      data: {dialogTitle: 'Delete Module?', accept: 'true'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== null && result !== undefined) {
        if (result === 'true') {
          this.modulesDataManager.deleteModule(moduleId).subscribe(
              (response) => {
                this.showMessage('Module deleted');
                this.ngOnInit();
              },
              (err) => {
                this.showError(err.json());
              });
        }
      }
    });
  }

  updateValue(event, cell, rowIndex) {
    const moduleId = this.rows[rowIndex]._id;
    this.modulesDataManager.updateOrder(moduleId, event.target.value)
        .subscribe(
            (response) => {
              this.ngOnInit();
              this.showMessage('Order updated');
            },
            (err) => {
              this.showError(err.json());
            }

        );
  }

  showMessage(message: string) {
    this.snackBar.open(message, null, {duration: 5000});
  }

  showError(message: ErrorResponse) {
    if (message.errors !== null && message.errors !== undefined &&
        message.errors.length > 0) {
      this.snackBar.open(message.errors[0].message, null, {duration: 10000});
    } else {
      this.snackBar.open('Unknown error occured', null, {duration: 10000});
    }
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/modules/modules.component.ts